export default __webpack_public_path__ + "static/media/sub-category-fitness-activityRoom.43578b90.jpg";